// ERP stores foreign-currency rates on MXN's tiposCambio relation (as Sencha does).
// A rate is the MXN value of one unit of the selected currency.
export function currencyRateInMxn(currencyId, currencies = []) {
  const mxn = currencies.find(row => row.clave_moneda === 'MXN');
  if (!mxn || currencyId == null || currencyId === '') return undefined;
  if (String(currencyId) === String(mxn.id)) return 1;
  const exchange = (mxn.tipos_cambio || mxn.tiposCambio || []).find(row =>
    String(row.pivot?.id_moneda_exchange ?? row.id) === String(currencyId));
  const rate = Number(exchange?.pivot?.tipo_cambio);
  return Number.isFinite(rate) && rate > 0 ? rate : undefined;
}
